import React, { useEffect, useState } from 'react';
import { Box, Button, TextField, Autocomplete } from '@mui/material';

import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { useDispatch, useSelector } from 'react-redux';
import {
  assignBatchByCroForNonAssignedLeads,
  getcroBatchesForNonAssignedLeads,
} from '../../../redux/features/batchSlice';

const AssignBatchModal = ({ open, setOpen, batchList, selectedLeads, onSuccess }) => {
  const dispatch = useDispatch();

  const { croBatchesForNonAssignedLeads, loading } = useSelector((state) => state.batch);
  const [selectedBatch, setSelectedBatch] = useState(null);

  useEffect(() => {
    if (open) {
      dispatch(getcroBatchesForNonAssignedLeads());
    }
  }, [open, dispatch]);

  const handleSubmit = () => {
    if (!selectedBatch) return;

    const payload = {
      batch_id: selectedBatch?.course_batch_id,
      data: Array.isArray(selectedLeads) ? selectedLeads : [selectedLeads],
    };

    console.log('FINAL PAYLOAD:', payload);

    dispatch(assignBatchByCroForNonAssignedLeads(payload))
      .unwrap()
      .then(() => {
        setOpen(false);
        setSelectedBatch(null);
        onSuccess?.();
      })
      .catch((err) => {
        console.error('Assign batch failed:', err);
      });
  };

  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      title="Assign Batch"
      maxWidth="sm"
      fullWidth
      closeButton
      content={
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <Autocomplete
            options={croBatchesForNonAssignedLeads || []}
            value={selectedBatch}
            onChange={(e, value) => setSelectedBatch(value)}
            getOptionLabel={(option) => option?.course_batch_name || ''}
            isOptionEqualToValue={(option, value) => option?.course_batch_id === value?.course_batch_id}
            loading={loading}
            renderInput={(params) => <TextField {...params} label="Select Batch" />}
          />

          <Button variant="contained" onClick={handleSubmit} disabled={!selectedBatch}>
            Submit
          </Button>
        </Box>
      }
    />
  );
};

export default AssignBatchModal;
